import { combineReducers } from "redux";
import userSlice from "./user";
import orgSlice from "./organization";
import patientSlice from "./patient";
import breadcrumbSlice from "./breadcrump";
import patientPaginationSlice from './pagination';
import adminApplicationPaginationSlice from './adminApplnState';
import dashboardSlice from './dashboardState';

const rootReducer = combineReducers({
	userReducer :  userSlice.reducer,
	orgReducer : orgSlice.reducer,
	patientReducer : patientSlice.reducer,
	breadcrumb : breadcrumbSlice.reducer,
	paginationReducer: patientPaginationSlice.reducer,
	adminApplicationReducer: adminApplicationPaginationSlice.reducer,
	dashboardReducer: dashboardSlice.reducer
});

export default rootReducer;
